// extracted by mini-css-extract-plugin
export default {"postJobContainer":"PostJob_postJobContainer__0sy9W","headerText":"PostJob_headerText__May5V","sectionContainer":"PostJob_sectionContainer__Py6FG"};